/* eslint-disable no-use-before-define */
import React from 'react'

export default {
    "ok": <svg width="83" height="81" viewBox="0 0 83 81" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M41.5284 78.3871C20.1813 78.3871 2.81263 61.3915 2.81263 40.5C2.81263 19.6085 20.1813 2.6129 41.5284 2.6129C62.8755 2.6129 80.2442 19.6085 80.2442 40.5C80.2442 61.3915 62.8755 78.3871 41.5284 78.3871ZM41.5284 0C18.7075 0 0.142578 18.1688 0.142578 40.5C0.142578 62.8312 18.7075 81 41.5284 81C64.3493 81 82.9142 62.8312 82.9142 40.5C82.9142 18.1688 64.3493 0 41.5284 0ZM35.687 48.4667L28.1174 41.1689L25.5942 43.6015L35.687 53.332L57.3144 32.481L54.7912 30.0484L35.687 48.4667Z" fill="#242424"/>
    <mask id="mask0_2300_45833" style={{"maskType":"luminance"}} maskUnits="userSpaceOnUse" x="0" y="0" width="83" height="81">
    <path fillRule="evenodd" clipRule="evenodd" d="M41.5284 78.3871C20.1813 78.3871 2.81263 61.3915 2.81263 40.5C2.81263 19.6085 20.1813 2.6129 41.5284 2.6129C62.8755 2.6129 80.2442 19.6085 80.2442 40.5C80.2442 61.3915 62.8755 78.3871 41.5284 78.3871ZM41.5284 0C18.7075 0 0.142578 18.1688 0.142578 40.5C0.142578 62.8312 18.7075 81 41.5284 81C64.3493 81 82.9142 62.8312 82.9142 40.5C82.9142 18.1688 64.3493 0 41.5284 0ZM35.687 48.4667L28.1174 41.1689L25.5942 43.6015L35.687 53.332L57.3144 32.481L54.7912 30.0484L35.687 48.4667Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_2300_45833)">
    </g>
    </svg>,

}



// WEBPACK FOOTER //
// ./src/orders/confirm/icons.js